import PluginRegistry from "../../pluginsInfrastructure/PluginRegistry";
import {
  ComponentToBeRegistered,
  Placeholder,
  PlaceholderPlugin,
  PluginEnableContext,
  SupportedPluginContentfulDataType,
} from "../../pluginsInfrastructure/PluginRegistryTypes";
import { isMailingServicesMpv } from "../../utils/mailingServicesUtil";
import { PriceInfoProps } from "./PriceInfo/PriceInfo";
import loadable from "@loadable/component";
import { QuantitySelectorProps } from "./QuantitySelector/QuantitySelector";
import { PriceCalculatorProps } from "./PriceCalculator/PriceCalculator";
import { addressAndMailingServices } from "../pluginOwners";

export const PriceInfoComponent: ComponentToBeRegistered<PriceInfoProps> = {
  placeholder: Placeholder.Pricing,
  Component: loadable(() => import("./PriceInfo/PriceInfo")),
  name: "MailingServicesPriceInfo",
  dataNeeds: {
    contentful: {
      priceInfo: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page V2 > Mailing Service Price Info",
      },
      shippingCallout: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page V2 > Mailing Service Shipping Callout",
      },
      outOfStockButtonAttribute: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page v2 > Out Of Stock",
      },
      recommended: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "callout.Recommended",
      },
      newCalloutText: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "callout.New",
      },
    },
  },
  enable: (context: PluginEnableContext, parentComponents: string[]) => {
    const {
      pageProps: { locale, mpv },
    } = context;
    return isMailingServicesMpv(mpv.mpvId, locale);
  },
};

export const QuantitySelectorComponent: ComponentToBeRegistered<QuantitySelectorProps> = {
  placeholder: Placeholder.QuantityDropdown,
  Component: loadable(() => import("./QuantitySelector/QuantitySelector")),
  name: "MailingServicesQuantitySelector",
  dataNeeds: {
    contentful: {
      mailingServicePricingCalculatorQuantityLabel: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page V2 > Mailing Service Pricing Calculator Quantity Label",
      },
      mailingServicePricingCalculatorQuantityUnits: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page V2 > Mailing Service Pricing Calculator Quantity Units",
      },
    },
  },
  enable: (context: PluginEnableContext, parentComponents: string[]) => {
    const {
      pageProps: { locale, mpv },
    } = context;
    return isMailingServicesMpv(mpv.mpvId, locale);
  },
};

export const PriceCalculatorComponent: ComponentToBeRegistered<PriceCalculatorProps> = {
  placeholder: Placeholder.AfterTab,
  Component: loadable(() => import("./PriceCalculator/PriceCalculator")),
  name: "MailingServicesPriceCalculator",
  dataNeeds: {
    contentful: {
      mailingServicePricingCalculatorHeader: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page V2 > Mailing Service Pricing Calculator Header",
      },
      mailingServicePricingCalculatorDescription: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page V2 > Mailing Service Pricing Calculator Description",
      },
      dropdownIncompatibleMessage: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Dropdown Incompatible Option Message",
      },
      mailingServiceFee: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page V2 > Mailing Service Fee",
      },
      postageFee: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page V2 > Postage Fee",
      },
      mailingServiceTotal: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Total",
      },
    },
  },
  enable: (context: PluginEnableContext, parentComponents: string[]) => {
    const {
      pageProps: { locale, mpv },
    } = context;
    return isMailingServicesMpv(mpv.mpvId, locale);
  },
};

export const mailingServices: PlaceholderPlugin = {
  init(pluginRegistry: PluginRegistry) {
    pluginRegistry.addComponent(this, PriceInfoComponent);
    pluginRegistry.addComponent(this, QuantitySelectorComponent);
    pluginRegistry.addComponent(this, PriceCalculatorComponent);
  },
  pluginOwner: addressAndMailingServices,
};
